import type { DashboardFilters } from './services';

/** Query keys for TanStack Query - hierarchical so one invalidation covers a subtree. */
export const queryKeys = {
  sponsored: ['sponsored'] as const,
  sponsoredAdmin: ['sponsored', 'admin'] as const,
  catalogAdmin: ['catalog-admin'] as const,
  me: ['me'] as const,
  lists: {
    all: ['lists'] as const,
    dashboards: ['lists', 'dashboard'] as const,
    dashboard: (filters: DashboardFilters) => ['lists', 'dashboard', filters] as const,
    detail: (id: string) => ['lists', 'detail', id] as const,
    items: (id: string) => ['lists', 'items', id] as const,
    members: (id: string) => ['lists', 'members', id] as const,
    shareLinks: (id: string) => ['lists', 'share-links', id] as const,
  },
  categories: ['catalog', 'categories'] as const,
  category: (id: string) => ['catalog', 'categories', id] as const,
  browse: (categoryId: string) => ['catalog', 'browse', categoryId] as const,
  search: (params: object) => ['catalog', 'search', params] as const,
  recent: ['catalog', 'recent'] as const,
  favorites: ['favorites'] as const,
  cuisines: ['meals', 'cuisines'] as const,
  cuisine: (id: string) => ['meals', 'cuisines', id] as const,
  cuisineMeals: (id: string) => ['meals', 'cuisines', id, 'meals'] as const,
  meal: (id: string) => ['meals', 'meal', id] as const,
  publicList: (token: string) => ['public-list', token] as const,
  shares: { pending: ['shares', 'pending'] as const },
  notifications: ['notifications'] as const,
};
